module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0004_05_A18_4.a3ad7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0004_05_A18_4.jpg
// module id = Rhy7
// module chunks = 0